import { Modal, Button } from 'antd';
import styles from './ConfirmDialog.module.scss';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  disableConfirm?: boolean;
  closable?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmLoading = false,
  disableConfirm = false,
  closable = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={
        <div className={styles.footer} data-testid="confirm-dialog-footer">
          <Button type="primary" onClick={onConfirm} loading={confirmLoading} disabled={disableConfirm}>
            {confirmText}
          </Button>
          <Button type="default" onClick={onCancel} className={styles.cancelButton}>
            {cancelText}
          </Button>
        </div>
      }
      title={
        <div className={styles.titleBar} data-testid="confirm-dialog-title">
          <span className={styles.title}>{title}</span>
        </div>
      }
      closable={closable}
      destroyOnHidden
      centered
      width={520}
      className={styles.modal}
    >
      <div className={styles.body} data-testid="confirm-dialog-body">
        {message}
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
